module.exports = "/lucky-balls/img/drum/drum_loop_008.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drum/drum_loop_008.png
// module id = 1023
// module chunks = 0